import { Component, OnInit } from '@angular/core';
import { AdalService } from '../adal/adal.service';

@Component({
    selector: 'home',
    template: require('./home.component.html'),
})
export class HomeComponent implements OnInit {
    public message: string;
    public values: any[];
    public userInfo: any;

    constructor(private adalService: AdalService) {
        this.userInfo = this.adalService.userInfo;
    }

    ngOnInit() {
        if (this.userInfo.isAuthenticated) {
            this.adalService.logOut();
            this.adalService.clearCache();
        }
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/home/home.component.ts
 **/